module.exports = __webpack_public_path__ + "img/ftr-mail.d90ea44b.svg";